export const types = <const>{
	mutations: {
		PNV_ZAKAZNIK_LIST_MAPPER: 'PNV_ZAKAZNIK_LIST_MAPPER',
		PNV_PRACOVNIK_LIST_MAPPER: 'PNV_PRACOVNIK_LIST_MAPPER',
		PNV_ZAKAZNIK_SELECT_MAPPER: 'PNV_ZAKAZNIK_SELECT_MAPPER',
		PNV_PRACOVNIK_SELECT_MAPPER: 'PNV_PRACOVNIK_SELECT_MAPPER',
	},
};
